import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import Badge from "@mui/material/Badge";

import {setLookActiveCategory, setLookOpened, setLookPageOpened} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import {GroheListIcon, LookCartIcon, LookLayoutIcon} from "../../../common/icons";
import COLOR_THEMES, {COLORS} from "../../../../colorThemes";
import LookCanvasContext from "../../lookCanvasContext";
import {zoomCanvasOut} from "../../lookNavigation/lookFunctions";
import {setCanvasScale} from "../../../../actions/actionFunctions";
import {getLookIdUrl, hideFeatureSection} from "../../lookNavigation/lookFunctions2";
import {setGroheSubCategoryOpened} from "../../../../actions/groheFunctions";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {getCurrentLayout} from "../../../appLayout";
import {getCartItemsCount} from "./groheFunctions";
import {setWizardActiveItem} from "../../../../actions/wizardFunctions";
import {isIframe} from "../../../../misc/helpers";

const GroheSidebarHeader = (props) => {

  const {setLookPageOpened, lookPageOpened, activeTheme, intl, lookActiveCategory, setLookActiveCategory,
    history, setCanvasScale, subCategoryOpened, setGroheSubCategoryOpened, lookOpened,
    setLookOpened, groheSameColorSectionOpened, isMobile, fabricatorSettings, cartItems, filtersOpened, shopPageOpened,
    lookActiveFeature, wizardActiveItem, setWizardActiveItem, shopPageLoaded, lookCompatabilityAlert,
    isSolidSurface, isLixil} = props;

  const layoutsOpened = lookPageOpened === ROUTES.view || lookPageOpened === ROUTES.rooms;
  const categoriesOpened = lookPageOpened === ROUTES.category;
  const isLixilIframe = isLixil && isIframe();

  const headerButtonClick = (imageCanvas, route) => {
    const analyticsLabel = route === ROUTES.category
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productSidebarHeaderAllProducts
      : PRODUCT_JOURNEY_ANALYTIC_EVENTS.productSidebarHeaderRoomLayouts;
    Analytics.sendClickEvent(analyticsLabel);
    if (!lookOpened) {
      setLookOpened(true);
    } else if (shopPageOpened) {
      setLookOpened(null);
      setLookPageOpened("");
    }
    if (lookActiveCategory) {
      setLookActiveCategory("");
    }
    if (lookPageOpened === route) {
      setLookOpened(null);
      setLookPageOpened("");
    } else {
      setLookPageOpened(route);
    }
    if (!shopPageOpened && lookPageOpened !== route) {
      if (route === ROUTES.category) {
        history.push(getLookIdUrl());
      } else {
        history.push(ROUTES.view);
      }
    }
    if (subCategoryOpened) {
      setGroheSubCategoryOpened("");
    }
    if (wizardActiveItem) {
      setWizardActiveItem(null);
    }
    zoomCanvasOut(imageCanvas, setCanvasScale);
  };

  const cartButtonClick = (imageCanvas) => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productSidebarHeaderCart);
    setLookPageOpened(ROUTES.cart);
    history.push(ROUTES.cart);
    if (lookOpened) {
      setLookOpened(false);
    }
    if (lookActiveCategory) {
      setLookActiveCategory("");
    }
    if (subCategoryOpened) {
      setGroheSubCategoryOpened("");
    }
    if (wizardActiveItem) {
      setWizardActiveItem(null);
    }
    zoomCanvasOut(imageCanvas, setCanvasScale);
  };

  const opened = (wizardActiveItem || lookOpened) && !isMobile && !shopPageOpened;
  const layout = getCurrentLayout();
  const hidden = groheSameColorSectionOpened
    || (lookActiveCategory && lookOpened && !layout.partIdExistInQtCategory(lookActiveCategory) && !lookCompatabilityAlert.visible && !filtersOpened)
    || (lookPageOpened && lookPageOpened.includes(ROUTES.cart))
    || (!wizardActiveItem && hideFeatureSection(lookOpened, lookActiveCategory, lookActiveFeature, lookCompatabilityAlert));

  const cartItemsLength = getCartItemsCount(cartItems, intl);

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <header className={"grohe-sidebar__header grohe-sidebar__header--fixed"
          + (opened || shopPageOpened ? " grohe-sidebar__header--on-top" : "")
          + (isSolidSurface ? " grohe-sidebar__header--cart-only" : "")
          + (shopPageOpened && !shopPageLoaded ? " grohe-sidebar__header--shop-loading" : "")
          + (hidden ? " grohe-sidebar__header--hidden" : "")}>
          {isSolidSurface ? null : (
            <div className="grohe-sidebar__header-cell">
              <IconButton aria-label={intl.formatMessage({id:"grohe.header.allProducts"})}
                          className={"look-icon look-icon--small1" + (categoriesOpened ? " look-icon--active" : "") + (!lookOpened ? " look-icon--grohe" : "")}
                          onClick={() => headerButtonClick(imageCanvas, ROUTES.category)}>
                <SvgIcon>
                  <GroheListIcon color={categoriesOpened ? COLORS.white : COLOR_THEMES[activeTheme].primary}/>
                </SvgIcon>
              </IconButton>
              <span className="grohe-sidebar__header-button-text"
                    onClick={() => headerButtonClick(imageCanvas, ROUTES.category)}>
                <FormattedMessage id="grohe.header.allProducts"/>
              </span>
            </div>
          )}
          {shopPageOpened || isSolidSurface ? null : (
            <div className="grohe-sidebar__header-cell">
              <IconButton aria-label={intl.formatMessage({id:"grohe.header.rooms"})}
                          className={"look-icon look-icon--small1" + (layoutsOpened ? " look-icon--active" : "") + (!lookOpened ? " look-icon--grohe" : "")}
                          onClick={() => headerButtonClick(imageCanvas, ROUTES.rooms)}>
                <SvgIcon>
                  <LookLayoutIcon color={layoutsOpened ? COLORS.white : COLOR_THEMES[activeTheme].primary}/>
                </SvgIcon>
              </IconButton>
              <span className="grohe-sidebar__header-button-text"
                    onClick={() => headerButtonClick(imageCanvas, ROUTES.rooms)}>
                <FormattedMessage id="grohe.header.rooms"/>
              </span>
            </div>
          )}
          {fabricatorSettings.checkout && !isLixilIframe ? (
            <div className="grohe-sidebar__header-cell">
              <Badge badgeContent={cartItemsLength} color="primary" invisible={!cartItemsLength}>
                <IconButton aria-label={intl.formatMessage({id:"iconButton.cart"})}
                            className={"look-icon look-icon--small1" + (!lookOpened ? " look-icon--grohe" : "")}
                            onClick={() => cartButtonClick(imageCanvas)}>
                  <SvgIcon>
                    <LookCartIcon />
                  </SvgIcon>
                </IconButton>
              </Badge>
              <span className="grohe-sidebar__header-button-text"
                    onClick={() => cartButtonClick(imageCanvas)}>
                <FormattedMessage id="grohe.header.cart"/>
              </span>
            </div>
          ) : null}
        </header>
      )}
    </LookCanvasContext.Consumer>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened, lookActiveCategory, lookOpened, lookActiveFeature, lookCompatabilityAlert} = store.lookState;
  const {activeTheme, isMobile, visualizersLoaded} = store.serverState;
  const {subCategoryOpened, groheSameColorSectionOpened, filtersOpened} = store.groheState;
  const {settings, isSolidSurface, isLixil} = store.fabricatorState;
  const {cartItems} = store.cartState;
  const {shopPageOpened, shopPageLoaded} = store.shopState;
  const {wizardActiveItem} = store.wizardState;

  return {
    lookOpened,
    lookPageOpened,
    lookActiveCategory,
    lookActiveFeature,
    activeTheme,
    subCategoryOpened,
    groheSameColorSectionOpened,
    isMobile,
    fabricatorSettings: settings,
    isSolidSurface,
    isLixil,
    cartItems,
    filtersOpened,
    shopPageOpened,
    visualizersLoadedLength: visualizersLoaded.length,
    wizardActiveItem,
    shopPageLoaded,
    lookCompatabilityAlert,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookActiveCategory,
  setCanvasScale,
  setGroheSubCategoryOpened,
  setLookOpened,
  setWizardActiveItem,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheSidebarHeader)
  )
)
